import { UserAccountAddress } from './UserAccountAddress';

export class UpdateUserAccount {
  firstName: string;
  lastName: string;
  organization: string;
  email: string;
  address: UserAccountAddress;
  phoneCountryCode: number;
  phoneNumber: string;
  faxCountryCode: number;
  fax: string;
}
